import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllBandhaiReceipt = createAsyncThunk(
  "BandhaiReceipt/FindAllBandhaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/FindAllBandhaiReceipt`,
        formdata,
      );
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fatching Bandhai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createBandhaiReceipt = createAsyncThunk(
  "BandhaiReceipt/InsertBandhaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/InsertBandhaiReceipt`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Bandhai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateBandhaiReceipt = createAsyncThunk(
  "BandhaiReceipt/UpdateBandhaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/UpdateBandhaiReceipt`,
        formdata,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Bandhai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhaiReceipt = createAsyncThunk(
  "BandhaiReceipt/DeleteBandhaiReceipt",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/DeleteBandhaiReceipt`,
        { bandhai_receipt_guid: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Delete Bandhai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBandhaiReceiptById = createAsyncThunk(
  "BandhaiReceipt/FindByIDBandhaiReceipt",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/FindByIDBandhaiReceipt`,
        { bandhai_receipt_guid: ID },
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        bandhai_receipt_guid: result.bandhai_receipt_guid,
        karigar_id: result.karigar_id,
        receipt_no: result.receipt_no,
        receipt_date: result.receipt_date
          ? moment(result.receipt_date, "YYYY-MM-DD").toDate()
          : "",
        karigar_name: result.karigar_name,
        karigar_nick_name: result.karigar_nick_name,
        bandhai_receipt_order: result.bandhai_receipt_order?.length
          ? result.bandhai_receipt_order.map((order: any) => {
              return {
                ...order,
                issize: order.issize ? order.issize : false,
                isweight: order.isweight ? order.isweight : false,
                isdesign: order.isdesign ? order.isdesign : false,
                iscaret: order.iscaret ? order.iscaret : false,
                isgoldcolor: order.isgoldcolor ? order.isgoldcolor : false,
                iseverythingasdescription: order.iseverythingasdescription
                  ? order.iseverythingasdescription
                  : false,
                ispolishcolor: order.ispolishcolor
                  ? order.ispolishcolor
                  : false,
                isfinishorder: order.isfinishorder
                  ? order.isfinishorder
                  : false,
                approval_items: order.approval_items?.length
                  ? order.approval_items?.map((approvalItem: any) => {
                      return {
                        ...approvalItem,
                        IssueDate: approvalItem.IssueDate
                          ? moment(
                              approvalItem.IssueDate,
                              "YYYY-MM-DD",
                            ).toDate()
                          : null,
                      };
                    })
                  : [],

                bandhai_gold_receive: order.bandhai_gold_receive
                  ? order.bandhai_gold_receive.map((item: any) => {
                      return {
                        id: item.id ? item.id : 0,
                        item_id: item.item_id,
                        ReceiveDate: item.ReceiveDate
                          ? moment(item.ReceiveDate, "YYYY-MM-DD").toDate()
                          : null,
                        ReceiveWeight: item.ReceiveWeight
                          ? +item.ReceiveWeight
                          : 0,
                        pcs: item.pcs ? +item.pcs : 0,
                      };
                    })
                  : [],
              };
            })
          : [],
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bandhai Receipt:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhaiReceiptOrderItem = createAsyncThunk(
  "BandhaiReceipt/DeleteBandhaiReceiptProcess",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/DeleteBandhaiReceiptProcess`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Receipt Process:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhaiReceiptApprovalItem = createAsyncThunk(
  "BandhaiReceipt/DeleteBandhaiReceiptApprovedItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/DeleteBandhaiReceiptApprovedItem`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Receipt Approval Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteBandhaiReceiptUsedByKarigarItem = createAsyncThunk(
  "BandhaiReceipt/DeleteBandhaiReceiptIssuedByKarigarItem",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/DeleteBandhaiReceiptIssuedByKarigarItem`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Receipt Karigar Item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByOrderNoBandhaiReceipt = createAsyncThunk(
  "BandhaiReceipt/FindByOrderNoBandhaiReceipt",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/FindByOrderNoBandhaiReceipt`,
        formdata,
      );
      const result = response.data?.Data as any;
      return {
        order_no: result.order_no,
        order_id: result.order_id,
        item_id: result.item_id,
        ghat_id: result.ghat_id,
        item_name: result.item_name,
        order_vepari_remark: result.remark,
        order_issue_remarks: result.remarks,
        order_process_description: result.process_description,
        item_category_id: result.item_category_id,
        weight: result.weight,
        purity_id: result.purity_id,
        item_image: result.item_image,
        approval_items: result.approval_items,
        sizedetails: result.sizedetails,
        order_date: result.order_date,
        delivery_date: result.delivery_date,
        product_name: result.product_name,
        category_name: result.category_name,
        sub_category_name: result.subcategory_name,
        order_estimate_weight: result.order_estimate_weight,
        size: result.size,
        purity: result.purity,
        color: result.color,
        priority: result.priority,
        Order_remark: result.Order_remark,
        karigar_name: result.karigar_name,
        given_date: result.given_date,
        receive_date: result.receive_date,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Bandhai Issue Order:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllOrderBandhaiIssue = createAsyncThunk(
  "BandhaiReceipt/BandhaiPendingOrderList",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/BandhaiPendingOrderList`,
        formdata,
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Find All Bandhai Issue:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const BandhaiReceiptImageUpdate = createAsyncThunk(
  "BandhaiReceipt/BandhaiReceiptImageUpdate",
  async (ghatReceipt: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/BandhaiReceiptImageUpdate`,
        ghatReceipt,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Bandhai Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const deleteBandhaiReceiptImage = createAsyncThunk(
  "BandhaiReceipt/DeleteBhandhaireceiptImage",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/BandhaiReceipt/DeleteBhandhaireceiptImage`,
        { id: ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Bandhai Receipt Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
